import React from "react";
import { makeStyles } from "@mui/styles";
import { TextField, Autocomplete } from "@mui/material";
import clsx from "clsx";

const useStyle = makeStyles(theme => ({
  root: {
    margin: 0
  },
  error: {
    height: 24,
    marginTop: 4,
  },
  mono: {
    fontFamily: "Roboto Mono",
  },
  textField: {
    marginTop: 0,
  },
}));
const default_opt = [
]

/** TODO: 
 * Define dropdown-search input field
 *  
 * @param {any} value - value of the text input
 * @param {function} onSelect - callback function when value is changed
 * @param {function} onInput - callback function when input is changed
 * @param {string} inputValue - input value
 * @param {node} label - label content
 * @param {bool} required - whether the input is required
 * @param {bool} disabled - whether the component is disabled
 * @param {array} options - array of options to autocomplete from
 * @param {bool} loading - whether the component is in loading state 
 * @param {node} helperText - helper text content
 * @param {string} className - override or extend styles of component 
 * @param {bool} error - if true, label will be displayed in error state
 * 
 * @return {Autocomplete component} - 
 */
const SearchSelect = props => {
  const {
    value, onSelect, onInput, inputValue = "", label, required, disabled,
    options = default_opt, loading, helperText, className, error, ...rest
  } = props;
  const classes = useStyle();
  return (
    <Autocomplete
      className={clsx(classes.root, className)}
      disabled={disabled}
      value={value}
      required={required}
      inputValue={inputValue}
      onChange={onSelect}
      loading={!!loading}
      onInputChange={onInput}
      options={options.map((opt) => opt.name)}
      renderInput={(params) => (
        <TextField
          {...params}
          className={classes.textField}
          label={label || "Search"}
          required={required}
          helperText={error}
          error = {error!== " "}
          InputProps={{ ...params.InputProps,}}
        />
      )}
      {...rest}
    />
  );
};
SearchSelect.propTypes = {

};

SearchSelect.defaultProps = {
}

export default SearchSelect;